import React, { useState } from "react";
import styled from "styled-components";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Img, WmkImage } from "wmk-image";

const GalleryWrap = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 60vh;
  .gatsby-image-wrapper {
    position: absolute;
    height: 100% !important;
    width: 100% !important;
    top: 0;
    left: 0;
  }
  .gallery-controls {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    .gal-meta {
      position: absolute;
      z-index: 2;
      bottom: 1rem;
      left: 1rem;
      padding: 0 0.5rem;
    }
    .gal-control {
      position: absolute;
      z-index: 3;
      bottom: 1rem;
      right: 2rem;
      button {
        padding: 0 0.5rem;
        background: none;
        appearance: none;
        border: 0;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .gal-img {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 100%;
    transition: all 0.5s ease;
    opacity: 0;
    &.active {
      left: 0;
      opacity: 1;
      transition: all 0.5s ease;
    }
    & > img {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
`;

const CustomGallery = ({ img }: { img: Img[] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const totalImg = img.length;

  const handleNext = () => {
    const active = activeIndex,
      total = totalImg;
    if (active < total - 1) {
      setActiveIndex(active + 1);
    } else {
      setActiveIndex(0);
    }
  };
  const handlePrev = () => {
    const active = activeIndex,
      total = totalImg;
    if (active === 0) {
      setActiveIndex(total - 1);
    } else {
      setActiveIndex(active - 1);
    }
  };
  return (
    <GalleryWrap className="gallery-wrap">
      {totalImg &&
        img.map((image, i) => {
          const activeClass = activeIndex === i ? " active" : "";
          return (
            <WmkImage
              image={image}
              key={"gal-img-" + i + image.title}
              className={"gal-img" + activeClass}
            />
          );
        })}
      <div className="gallery-controls">
        <div className="gal-meta">{activeIndex + 1 + " of " + totalImg}</div>
        <div className="gal-control">
          <button
            className="prev"
            onClick={handlePrev}
            aria-label="click to view previous work in gallery"
          >
            <IoIosArrowBack />
          </button>
          <button
            className="next"
            onClick={handleNext}
            aria-label="click to view next work in gallery"
          >
            <IoIosArrowForward />
          </button>
        </div>
      </div>
    </GalleryWrap>
  );
};

export default CustomGallery;
